<template>
  <div class="container custom-container banner-carrossel">
    <carousel
      :items="1"
      :loop="true"
      :center="false"
      :autoplay="true"
      :autoheight="false"
      :autowidth="false"
      :dots="true"
      :nav="false"
      v-if="bannerList.length > 0"
    >
      <picture
        v-for="(item, index) in bannerList"
        :key="index"
        class="banner-carrossel--item"
      >
        <source
          :srcset="
            urlBanners + item.imagemMobile
          "
          media="(max-width: 991px)"
        />
        <img
          :src="urlBanners + item.imagemDesktop"
          alt=""
        />
      </picture>
    </carousel>
  </div>
</template>
<script>
import carousel from "vue-owl-carousel";
/* eslint-disable no-undef */
export default {
  components: {
    carousel,
  },
  data() {
    return {
      bannerList: [],
      urlBanners:
        process.env.NODE_ENV == "production"
          ? ""
          : "https://br-heliarexpress-qa.clarios.com",
    };
  },
  created() {
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      $.ajax({
        url:
          process.env.NODE_ENV == "production"
            ? "./api/PrimeiraEtapa/getImagens"
            : "https://br-heliarexpress-qa.clarios.com/api/primeiraEtapa/getImagens",
        type: "GET",
        success: (response) => {
          this.bannerList = response.banner;
        },
        error: () => {
          swal
            .fire({
              title: "Ops",
              text: "Algo deu errado e a página será atualizada",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            })
            .then(() => {
              window.location.reload();
            });
        },
      });
    },
  },
};
</script>
<style lang="scss">
.banner-carrossel {
  position: relative;
  &--item {
    display: block;
    width: 100%;
    overflow: hidden;
    border-radius: 7px;
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .owl-dots {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (max-width: 991px) {
  .banner-carrossel {
    &.custom-container {
      max-width: 100%;
      padding: 0;
    }
    &--item {
      border-radius: 0;
    }
    .owl-dots {
      bottom: 90px;
    }
  }
}
@media (max-width: 575px) {
  .banner-carrossel {
    .owl-dots {
      bottom: 60px;
    }
  }
}
</style>
